module.exports = __webpack_public_path__ + "img/payment-success.b7ab41fc.jpg";